<template>
  <v-list class="pa-4">
    <v-list-item
      v-for="language in languages"
      :key="language.iso"
      :data-qa="`language-${language.iso}`"
      width="260px"
      class="d-flex align-center justify-center cursor-pointer"
      @click="redirectToOtherLanguage(language)"
    >
      <v-img
        :src="language.flag_image.url"
        width="24px"
        :alt="language.iso"
        class="mr-4"
      />
      <v-list-item-title>
        {{ language.translations[`name_${language.iso}`] || language.name }}
      </v-list-item-title>
      <v-icon
        v-if="language.iso === currentLanguage.iso"
        color="primary"
        size="24"
      >
        ui-icon-check
      </v-icon>
    </v-list-item>
  </v-list>
</template>

<script setup lang="ts">
import type { ContextStore, Language } from 'src/layouts/core-layout/types'
import sendYaGoal from 'src/utils/sendYaGoal'
import { useContextStore } from 'src/store'
import sendGoogleGoal from 'src/utils/sendGoogleGoal'

const { context }: ContextStore = useContextStore()
const currentLanguage = context.current_language

defineProps<{
  languages: Language[]
}>()

function redirectToOtherLanguage(language: Language) {
  if (process.env.IS_SERVER) {
    return
  }

  if (language.iso === currentLanguage.iso) {
    return
  }

  sendYaGoal(`languagesList__click-${language.iso}`)
  sendGoogleGoal(`languagesList__click-${language.iso}`)

  const { pathname, origin, search } = window.location
  const isoInUrl = new RegExp(`^/(${currentLanguage.iso})/`)

  if (context.default_language_iso === language.iso) {
    window.location.href = `${origin}${pathname.replace(isoInUrl, '/')}${search}`

    return
  }

  if (context.default_language_iso === currentLanguage.iso) {
    window.location.href = `${origin}/${language.iso}${pathname.replace(isoInUrl, '')}${search}`

    return
  }

  window.location.href = `${origin}/${language.iso}/${pathname.replace(isoInUrl, '')}${search}`
}
</script>
